/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResendEnrollmentOTPRequest } from '../models/ResendEnrollmentOTPRequest';
import type { ResendEnrollmentOTPResponse } from '../models/ResendEnrollmentOTPResponse';
import type { StartWhatsAppEnrollmentResponse } from '../models/StartWhatsAppEnrollmentResponse';
import type { SubmitEnrollmentRequest } from '../models/SubmitEnrollmentRequest';
import type { SubmitEnrollmentResponse } from '../models/SubmitEnrollmentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnrollmentService {
    /**
     * Start WhatsApp Enrollment
     * Start a WhatsApp authenticator enrollment flow (requires escalation)
     * @param userSession
     * @returns StartWhatsAppEnrollmentResponse Successful Response
     * @throws ApiError
     */
    public static startWhatsappEnrollment(
        userSession?: (string | null),
    ): CancelablePromise<StartWhatsAppEnrollmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/start-whatsapp',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Enrollment OTP
     * Submit OTP code to complete enrollment (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns SubmitEnrollmentResponse Successful Response
     * @throws ApiError
     */
    public static submitEnrollment(
        requestBody: SubmitEnrollmentRequest,
        userSession?: (string | null),
    ): CancelablePromise<SubmitEnrollmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/submit',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resend WhatsApp Enrollment OTP
     * Resend WhatsApp OTP code during enrollment (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns ResendEnrollmentOTPResponse Successful Response
     * @throws ApiError
     */
    public static resendEnrollmentWhatsappOtp(
        requestBody: ResendEnrollmentOTPRequest,
        userSession?: (string | null),
    ): CancelablePromise<ResendEnrollmentOTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/resend-whatsapp-otp',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unenroll from WhatsApp
     * Remove WhatsApp authenticator enrollment for the current user (requires escalation)
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static unenrollWhatsapp(
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/enrollment/whatsapp/unenroll',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
